import { render, staticRenderFns } from "./WorkoutSplitEdit.vue?vue&type=template&id=169a3552&scoped=true"
import script from "./WorkoutSplitEdit.vue?vue&type=script&lang=js"
export * from "./WorkoutSplitEdit.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSplitEdit.vue?vue&type=style&index=0&id=169a3552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169a3552",
  null
  
)

export default component.exports